import type { EnumCallStatusApi } from '@ingenico/api-sdk-device-management-private-v2';
import { SEARCH_DEBOUNCE_TIMEOUT } from '@ingenico/react-ui/consts';
import { useDebouncedCallback } from '@react-hookz/web';
import { useState } from 'react';

export function useSearchQuerySetup(setOffset: (o: number) => void) {
  const [searchQuery, setSearchQueryDispatch] = useState('');
  const [selectedQuickFilterValue, setSelectedQuickFilterValue] = useState<EnumCallStatusApi[]>();

  const setDebouncedSearchQuery = useDebouncedCallback(
    (text: string) => {
      setOffset(0);
      return setSearchQueryDispatch(text);
    },
    [],

    SEARCH_DEBOUNCE_TIMEOUT,
  );

  return { searchQuery, selectedQuickFilterValue, setDebouncedSearchQuery, setSelectedQuickFilterValue };
}
